import React from 'react'
import { TierOneSponsor, TierThreeSponsor } from './components'

export const EventTieredSponsor = (props) => {
  const { tier, size } = props

  const componentMap = (tier) => {
    let Component
    switch (size) {
      case 'large':
        Component = TierOneSponsor
        break
      case 'small':
        Component = TierThreeSponsor
        break
      default:
        Component = TierOneSponsor
        break
    }
    return <Component tier={tier.name} {...props} />
  }
  return componentMap(tier)
}
